export default {
  path: '/index',
  name: 'index',
  redirect: {
    name: 'memberCenter'
  },
  component: function component() {
    return import('@/layouts/basic-layout');
  },
  children: [// 配置中心-运维管理-数据字典维护
  {
    path: 'maxgraph',
    name: 'maxgraph',
    meta: {
      title: '流程图',
      cache: true
    },
    component: function component() {
      return import('@/pages/maxgraph/demo/index');
    }
  }]
};